export default __webpack_public_path__ + "cc5314d896fc1b1e8421acc420b27cc0.otf";